import React, { useContext } from 'react';

import TransmissionFilter from './TransmissionFilter';
import FuelTypeFilter from './FuelTypeFilter';
import { FilterContext } from '../internal';

const VehicleFilter = () => {
  const {
    filterMetaData: { transmissionTypes, fuelTypes },
    updateFilter
  } = useContext(FilterContext);
  return (
    <>
      <TransmissionFilter
        transmissionTypes={transmissionTypes}
        updateFilter={updateFilter}
      />
      <FuelTypeFilter fuelTypes={fuelTypes} updateFilter={updateFilter} />
    </>
  );
};

export default VehicleFilter;
